import { Card, Col, Row } from "antd";
import LineChart from "components/charts/LineChart";
import Scorecard from "components/charts/Scorecard";
import ChartTitle from "components/ChartTitle";
import { GRID_GUTTER } from "constants/ui";
import React, { useMemo } from "react";
import { isEmpty, sum } from "lodash";
import { useFormatNumber } from "hooks/useFormatNumber";
import { DIMENSION_DATE } from "constants/dimensions";
import { getDimensionColorByIndex } from "utils/colorUtils";

const DATAKEY_TOOLTIP_OPEN = "tooltipOpen";
const DATAKEY_MERKEN_CLICKS = "merkenClicks";
const DATAKEY_CLICK_RATE = "clickRate";

const FTUOverview = ({ data }) => {
  const formatNumber = useFormatNumber();

  const chartLines = useMemo(() => {
    return [
      {
        name: "Tooltip open",
        dataKey: DATAKEY_TOOLTIP_OPEN,
      },
      {
        name: "Merken button clicks",
        dataKey: DATAKEY_MERKEN_CLICKS,
      },
      // {
      //   name: "Click rate (%)",
      //   dataKey: DATAKEY_CLICK_RATE,
      // },
    ];
  }, []);

  const totalTooltipOpen = useMemo(() => {
    if (isEmpty(data)) return 0;
    return sum(data.map((item) => item[DATAKEY_TOOLTIP_OPEN] || 0));
  }, [data]);

  const totalMerkenClicks = useMemo(() => {
    if (isEmpty(data)) return 0;
    return sum(data.map((item) => item[DATAKEY_MERKEN_CLICKS] || 0));
  }, [data]);

  const overallClickRate = useMemo(() => {
    if (totalTooltipOpen === 0) return 0;
    return ((totalMerkenClicks / totalTooltipOpen) * 100).toFixed(1);
  }, [totalTooltipOpen, totalMerkenClicks]);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <Col span={24}>
        <ChartTitle>Tooltips overview</ChartTitle>
      </Col>
      <Col xs={24} lg={12} className="mb-8">
        <Card size="small">
          <LineChart
            xAxisDataKey={DIMENSION_DATE}
            data={data}
            lines={chartLines}
          />
        </Card>
      </Col>

      <Col xs={24} lg={12} className="mb-8">
        <Row gutter={GRID_GUTTER}>
          <Col xs={24} className="mb-8">
            <Card size="small">
              <Scorecard
                title="Tooltip Views (Unique Users)"
                value={formatNumber(totalTooltipOpen)}
                chartProps={{
                  data,
                  lines: [
                    {
                      name: "Tooltip open",
                      dataKey: DATAKEY_TOOLTIP_OPEN,
                      fill: getDimensionColorByIndex(0),
                    },
                  ],
                }}
              />
            </Card>
          </Col>

          <Col xs={24} md={12} className="mb-8">
            <Card size="small" className="lg:h-full">
              <Scorecard
                title="Merken button clicks"
                value={formatNumber(totalMerkenClicks)}
                chartProps={{
                  data,
                  lines: [
                    {
                      name: "Merken clicks",
                      dataKey: DATAKEY_MERKEN_CLICKS,
                      fill: getDimensionColorByIndex(1),
                    },
                  ],
                }}
              />
            </Card>
          </Col>

          <Col xs={24} md={12} className="mb-8">
            <Card size="small" className="lg:h-full">
              <Scorecard
                title="Click rate"
                value={`${overallClickRate}%`}
                chartProps={{
                  data,
                  lines: [
                    {
                      name: "Click rate %",
                      dataKey: DATAKEY_CLICK_RATE,
                      fill: getDimensionColorByIndex(2),
                    },
                  ],
                }}
              />
            </Card>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default FTUOverview;
